export default function GriSupplierReportDetailsData({ data, id }) {
    return (
        <>
            {
                data && data.length > 0 ? (
                    data.map((curData => {
                        return (
                            <tr key={id}>

                                <td>{curData['GRI STANDARD OTHER SOURCE']}</td>
                                <td>{curData['DISCLOSURE']}</td>
                                <td>{curData['LOCATION']}</td>
                                <td>{curData['REQUIREMENT(S) OMITTED']}</td>
                                <td>{curData['REASON']}</td>
                                <td>{curData['EXPLANATION']}</td>
                                <td>{curData['GRI SECTOR STANDARD REF. NO.']}</td>
                            </tr>
                        )
                    }))) : (
                    <span>No Tsp supplier reports details data available.</span>
                )
            }
        </>
    )
}